import React, { useState } from 'react';
import Sidebar from './SideBar';
import TopHeader from './TopHeader';

const AppLayout = ({ children }) => {
  // Sidebar collapsed state, persisted so it survives navigation/refresh.
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('sidebarCollapsed') === 'true');

  const toggleSidebar = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem('sidebarCollapsed', String(next));
      return next;
    });
  };

  return (
    <div className="flex h-screen w-screen bg-slate-100 dark:bg-slate-900 font-sans">
      <Sidebar collapsed={collapsed} onToggle={toggleSidebar} />

      <div className="flex flex-1 flex-col overflow-hidden">
        <TopHeader />

        {/*
          Option A:
          - min-h-0 lets this flex child shrink below its content height,
            which is what allows a nested height:100% grid to resolve.
          - overflow-hidden (not auto) so full-bleed pages control their own
            scrolling. Short/simple pages should wrap their content in a
            scrollable, padded div, e.g. <div className="h-full overflow-y-auto p-6">.
        */}
        <main className="flex-1 min-h-0 overflow-hidden">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
